import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconType, Icons } from '../../../constants/icons';
import { Profile } from '../../../models/UserStore';
import { AvatarNode } from '../AvatarNode';
import { Card } from '../Card';

type UserViewCardProps = {
  profile: Profile | null | undefined;
  backgroundColor?: string;
};

export const UserViewCard = memo((props: UserViewCardProps) => {
  const { profile, backgroundColor } = props;

  const { t } = useTranslation();
  return (
    <Card
      style={{
        backgroundColor: backgroundColor || '#f2f2f2',
        gap: '0.5rem',
        width: '100%',
        padding: '0.5rem 1rem',
        maxWidth: '456px',
      }}
    >
      <div
        className="flex flex-col"
        style={{ alignItems: 'start', width: '100%' }}
      >
        <div className="flex flex-row items-center gap-1">
          <p className="text-md font-bold">{profile?.name}</p>
          {profile?.isVerified ? (
            <img src={Icons[IconType.Certified]} className="size-icon-s" />
          ) : null}
        </div>
        <p className="text-md text-gray-600">
          {t('{count} followers', {
            count: profile?.statistics.homeMemberCount ?? 0,
          })}
        </p>
        {profile ? (
          <div
            className="flex justify-center items-center"
            style={{ width: '100%' }}
          >
            <div style={{ position: 'relative' }}>
              <AvatarNode
                avatar={{
                  ...profile?.avatar,
                  userId: profile?.userId,
                  source:
                    profile?.profilePicture &&
                    profile?.profilePicture.publicUrls?.small
                      ? { uri: profile?.profilePicture.publicUrls?.small }
                      : '',
                }}
                size={240}
              />
              {/* Level tag */}
              {profile?.exp.level > 0 ? (
                <span
                  className="font-bold text-2xl"
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    backgroundColor: 'black',
                    color: 'white',
                    padding: '0.2rem 0.6rem',
                    fontSize: '1.25rem',
                    borderRadius: '0.5rem',
                    margin: '1rem',
                  }}
                >
                  Lv. {profile?.exp.level}
                </span>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </Card>
  );
});
